import { useMemo } from 'react';
import {
  qAppConfig,
  getClinicContact,
  type AppConfigRow,
  type ClinicContact,
} from '@helios/data-access';
import { usePowerSyncQuery } from '../adapters/powersync';
import { orgPhone, orgEmail } from '../shell/shared';

/**
 * Reactive read of the clinic's contact details for the shell sidebar header.
 *
 * Clinic Settings (`app_config`) is the source of truth; the build-time
 * `VITE_SUPPORT_*` env vars are only a fallback for orgs that have not filled
 * the form in yet. This is the single place the shells read it from, so editing
 * Clinic Settings updates every shell mode live — no rebuild, no redeploy.
 */
export function useClinicContact(): ClinicContact {
  const { data } = usePowerSyncQuery<AppConfigRow>(qAppConfig());
  return useMemo(
    () => getClinicContact(data?.[0] ?? null, { phone: orgPhone, email: orgEmail }),
    [data],
  );
}
